import { gql } from '@apollo/client';

export const DELETE_REPLY_TO_POST_DRAFT_MUTATION = gql`
    mutation deleteReplyToPostDraft($id: String!, $userId: String!, $parentPostId: String!) {
        deleteReplyToPostDraft(id: $id, userId: $userId, parentPostId: $parentPostId)
    }
`;
